import React from 'react'
import FlexView from 'react-flexview/lib'
import './BellFrame.scss'

export const Frame = ({ children, ...props }) => {
  return (
    <>
      <div className="regular-frame">
        <FlexView vAlignContent={'center'} className="space-around">
          <div>{children}</div>
        </FlexView>
      </div>
    </>
  )
}
